export const EMAIL_IDENTIFIER_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isEmailIdentifier = (value: string | null | undefined): boolean => {
	if (!value) return false;
	return EMAIL_IDENTIFIER_REGEX.test(value.trim());
};
